import React, { useEffect, useState } from 'react';
import { FaSun, FaMoon } from 'react-icons/fa6';

const CLAVE = 'simplia_theme';
const EVENTO = 'simplia-theme-change';

const leer = () => {
    try {
        return localStorage.getItem(CLAVE) === 'dark';
    } catch {
        return false;
    }
};

/**
 * Tema claro / oscuro del detalle de cobranza, recordado en este navegador.
 * Todas las instancias (página, detalle) se mantienen sincronizadas.
 */
export function useTemaGestion() {
    const [oscuro, setOscuro] = useState(leer);

    useEffect(() => {
        const alCambiar = (e) => setOscuro(Boolean(e.detail));
        window.addEventListener(EVENTO, alCambiar);
        return () => window.removeEventListener(EVENTO, alCambiar);
    }, []);

    const cambiar = (valor) => {
        try {
            localStorage.setItem(CLAVE, valor ? 'dark' : 'light');
        } catch {
            // sin almacenamiento: el tema dura solo esta visita
        }
        window.dispatchEvent(new CustomEvent(EVENTO, { detail: valor }));
    };
    return [oscuro, cambiar];
}

/** Selector segmentado Claro / Oscuro (mockup "Selector de Tema"). */
export function SelectorTema({ oscuro, onCambiar }) {
    const base = 'flex items-center gap-1.5 px-2 sm:px-2.5 py-1 text-xs font-semibold rounded-md transition-all';
    return (
        <div role="radiogroup" aria-label="Selector de tema"
            className="bg-slate-100 dark:bg-[#1A2234] p-0.5 sm:p-1 rounded-lg border border-slate-200 dark:border-slate-700/80 flex items-center shadow-inner">
            <button type="button" role="radio" aria-checked={!oscuro} onClick={() => onCambiar(false)} title="Activar modo claro"
                className={`${base} ${!oscuro ? 'bg-amber-500 text-slate-900 shadow-sm font-bold' : 'text-slate-400 hover:text-slate-200'}`}>
                <FaSun className={`text-xs ${!oscuro ? 'text-slate-900' : 'text-amber-400'}`} />
                <span className="hidden sm:inline">Claro</span>
            </button>
            <button type="button" role="radio" aria-checked={oscuro} onClick={() => onCambiar(true)} title="Activar modo oscuro"
                className={`${base} ${oscuro ? 'bg-indigo-600 text-white shadow-sm font-bold' : 'text-slate-500 hover:text-slate-900'}`}>
                <FaMoon className={`text-xs ${oscuro ? 'text-indigo-200' : 'text-slate-500'}`} />
                <span className="hidden sm:inline">Oscuro</span>
            </button>
        </div>
    );
}
